module.exports = __webpack_public_path__ + "img/code-bg.352454c0.png";